/**
 * NIVORLA minimal storefront enhancements.
 * Presentation only: no changes to product forms, variants, cart logic,
 * templates, app blocks, links or Theme Editor configuration.
 */
(() => {
  const ICONS = {
    curate: '<svg class="nivorla-reassurance__icon" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 3l2.1 4.7L19 9.2l-3.7 3.4.9 5-4.2-2.4-4.2 2.4.9-5L5 9.2l4.9-1.5L12 3z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>',
    lock: '<svg class="nivorla-reassurance__icon" viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="5" y="10" width="14" height="10" rx="2" stroke="currentColor" stroke-width="1.5"/><path d="M8 10V7a4 4 0 018 0v3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>',
    support: '<svg class="nivorla-reassurance__icon" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 12a8 8 0 0116 0v5a2 2 0 01-2 2h-2v-6h4M4 12v5a2 2 0 002 2h2v-6H4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M9 21h6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>'
  };

  const enhanceProduct = (root) => {
    root.querySelectorAll('.product__info-container').forEach((container) => {
      const title = container.querySelector('.product__title');
      if (title && !title.querySelector(':scope > .nivorla-product-eyebrow')) {
        const eyebrow = document.createElement('p');
        eyebrow.className = 'nivorla-product-eyebrow';
        eyebrow.textContent = 'NIVORLA';
        title.prepend(eyebrow);
      }

      const buttons = container.querySelector('.product-form__buttons');
      if (!buttons || container.querySelector('.nivorla-reassurance')) return;

      const reassurance = document.createElement('div');
      reassurance.className = 'nivorla-reassurance';
      reassurance.setAttribute('aria-label', 'Shopping reassurance');
      reassurance.innerHTML = `
        <div class="nivorla-reassurance__item">${ICONS.curate}<span>Curated selection</span></div>
        <div class="nivorla-reassurance__item">${ICONS.lock}<span>Secure checkout</span></div>
        <div class="nivorla-reassurance__item">${ICONS.support}<span>Customer support</span></div>`;

      const secure = document.createElement('div');
      secure.className = 'nivorla-secure-note';
      secure.innerHTML = `${ICONS.lock.replace('nivorla-reassurance__icon', '')}<span>Encrypted &amp; secure checkout</span>`;

      buttons.insertAdjacentElement('afterend', reassurance);
      reassurance.insertAdjacentElement('afterend', secure);
    });
  };

  const enhance = (root = document) => {
    if (!document.body?.classList.contains('nivorla-curated-store')) return;
    enhanceProduct(root);
  };

  const start = () => enhance(document);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
})();

/** Mobile product purchase bar. Mirrors the active Dawn product form without
 * replacing or changing Shopify's variant/cart behavior. */
(() => {
  const initBuyBar = (root = document) => {
    if (!document.body?.classList.contains('template-product') || document.querySelector('.nivorla-mobile-buybar')) return;

    const form = root.querySelector('product-form form[action*="/cart/add"], form.product-form[action*="/cart/add"]');
    const sourceButton = form?.querySelector('[type="submit"]');
    const title = document.querySelector('.product__title h1, .product__title');
    const price = document.querySelector('.product__info-container .price');
    if (!form || !sourceButton || !title) return;

    const bar = document.createElement('div');
    bar.className = 'nivorla-mobile-buybar';
    bar.setAttribute('aria-label', 'Quick purchase');
    bar.innerHTML = `
      <div class="nivorla-mobile-buybar__meta">
        <span class="nivorla-mobile-buybar__title"></span>
        <span class="nivorla-mobile-buybar__price"></span>
      </div>
      <button class="nivorla-mobile-buybar__button" type="button"></button>`;

    document.body.appendChild(bar);
    document.body.classList.add('has-nivorla-buybar');

    const barTitle = bar.querySelector('.nivorla-mobile-buybar__title');
    const barPrice = bar.querySelector('.nivorla-mobile-buybar__price');
    const barButton = bar.querySelector('.nivorla-mobile-buybar__button');
    barTitle.textContent = title.textContent.trim();

    const sync = () => {
      const label = sourceButton.querySelector('span')?.textContent || sourceButton.textContent || 'Add to bag';
      barButton.textContent = label.trim();
      barButton.disabled = sourceButton.disabled;
      barPrice.textContent = price?.innerText?.trim().split('\n')[0] || '';
    };

    sync();
    new MutationObserver(sync).observe(sourceButton, { attributes: true, childList: true, subtree: true, characterData: true });
    if (price) new MutationObserver(sync).observe(price, { childList: true, subtree: true, characterData: true });

    barButton.addEventListener('click', () => {
      if (!sourceButton.disabled) sourceButton.click();
    });

    const observer = new IntersectionObserver(([entry]) => {
      bar.classList.toggle('is-visible', !entry.isIntersecting);
    }, { threshold: 0.2 });
    observer.observe(sourceButton);
  };

  const start = () => initBuyBar(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', (event) => initBuyBar(event.target));
})();
